<template>
  <component :is="layout">
    <template
      v-for="(_, name) in $scopedSlots"
      #[name]
    >
      <slot :name="name"></slot>
    </template>
  </component>
</template>
<script>
  import { ImageType, TrailerMode } from '@/shared/enums';
  import { viewportMixin } from '@/index/shared/mixins';
  import VBadge from '../badge/index.vue';
  import VProductLink from '../product-link/index.vue';
  import VTrailer from '../trailer/index.vue';
  import DefaultLayout from './layouts/default.vue';
  import DetailLayout from './layouts/detail.vue';

  export default {
    components: {
      VBadge,
      VTrailer,
      VProductLink,
    },
    enums: {
      ImageType,
    },
    mixins: [
      viewportMixin,
    ],
    props: {
      header: String,
      playOnHover: Boolean,
      product: Object,
      trailerMode: String,
    },
    computed: {
      imageType() {
        if (this.trailerMode === TrailerMode.BILLBOARD) {
          return ImageType.ARTWORK;
        }

        return this.isMobile ? ImageType.POSTER_ARTWORK : ImageType.ARTWORK;
      },
      layout() {
        switch (this.trailerMode) {
          case TrailerMode.DETAIL:
            return DetailLayout;
          default:
            return DefaultLayout;
        }
      },
      isMobile() {
        return this.$window.isMobileView;
      },
      shouldBeAutoPlayed() {
        return this.isMobile || !this.playOnHover;
      },
      trailerDelay() {
        return this.playOnHover ? 200 : null;
      },
    },
    mounted() {
      this.observe({
        threshold: 0.1,
      });
    },
    methods: {
      onViewportEnter() {
        if (this.shouldBeAutoPlayed) {
          this.playTrailer();
        }
      },
      onViewportLeave() {
        if (this.shouldBeAutoPlayed) {
          this.stopTrailer();
        }
        this.$emit('viewport-leave');
      },
      onTrailerEnded() {
        this.$emit('trailer-ended');
      },
      onWrapperMouseEnter({ target }) {
        if (!this.shouldBeAutoPlayed && target === this.$refs.wrapper) {
          this.playTrailer();
        }
      },
      onWrapperMouseLeave({ target }) {
        if (!this.shouldBeAutoPlayed && target === this.$refs.wrapper) {
          this.stopTrailer();
        }
      },
      playTrailer() {
        if (this.$refs.trailer?.play) {
          this.$refs.trailer.play();
        }
      },
      stopTrailer() {
        if (this.$refs.trailer?.stop) {
          this.$refs.trailer.stop();
        }
      },
    },
  };
</script>
